export default "__VITE_ASSET__345790b7__"